import OGoogleMaps from './o-google-maps.vue';

export default OGoogleMaps;